import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, TextField } from '@material-ui/core'
import PropTypes from 'prop-types'
import { Field, Form, Store } from 'react-formality'
import pick from './utilities/pick'
import getNormalisedParameters from './utilities/getNormalisedParameters'
import mapDispatchers from './utilities/mapDispatchers'
import styles from './Report.icss'
import getStartLocationForUser from './utilities/getStartLocationForUser'

class Report extends React.Component {
	static getDerivedStateFromProps(props) {
		const isReport = props.match.path.indexOf('/report') === 0
		return { reportType: isReport ? 'report' : 'feedback' }
	}

	constructor(props) {
		super(props)
		this.state = {
			store: new Store({
				userText: ''
			},
			(values) => {
				if (this.mounted) {
					// eslint-disable-next-line react/no-unused-state
					this.setState({ values })
				}
			})
		}
		this.handleReportSubmit = this.handleReportSubmit.bind(this)
	}

	componentDidMount() {
		this.mounted = true
		this.props.appHeading({ text: this.state.reportType === 'report' ? this.context.translate('Report') : this.context.translate('Feedback') })
		const parsedSearch = getNormalisedParameters(this.props.location.search)

		if (parsedSearch.isitemreport) {
			const userText = this.context.translate('I\'d like to request that you add an Item that I need for my Kit.\n\nitem url: \nbrand: \nitem name: \ncolour: \nAnything else useful: \n\n')
			this.state.store.set('userText', userText)
		}

		this.setState({
			location: parsedSearch.location,
			url: parsedSearch.url.substr(0, 1024)
		})
	}

	componentDidUpdate() {
		if (!this.props.pageHasLoaded) {
			this.props.appPageLoaded(true)
		}
	}

	componentWillUnmount() {
		this.mounted = false
	}

	handleReportSubmit(e, values, isValid) {
		if (isValid) {
			const userText = values.userText
			const report = {
				type: this.state.reportType,
				value: global.decodeURIComponent(global.encodeURIComponent(this.state.location)),
				userText,
				url: this.state.url,
				userName: this.props.user.userProfile.userName
			}
			this.props.reportSave(report)
			this.setState({ hasSubmitted: true })
		}
	}


	render() {
		return (
			<section className={styles.reportWrapper}>
				{this.state.url && (
					<div className={styles.container}>
						<h2>{this.state.reportType === 'report' ? this.context.translate('Report problem') : this.context.translate('Feedback')}</h2>
						{!this.state.hasSubmitted && (
							<Form store={this.state.store} onSubmit={this.handleReportSubmit}>
								<p>
									{this.state.reportType === 'report' ? this.context.translate('Use this to report to our team anything you think might be incorrect, offensive or otherwise a problem.') : this.context.translate('Use this to give feedback on the features of Kitfit - we want to hear your ideas!')}
								</p>
								<p>
									{this.state.reportType === 'report' ? this.context.translate('You are about to report the following URL:') : this.context.translate('You are about to give feedback on the following URL:')}
								</p>
								<p className={styles.url}>
									{this.state.url}
								</p>
								<p>
									{this.state.reportType === 'report' ? this.context.translate('I would like to report this url for the following reason:') : this.context.translate('My feedback is:')}
								</p>
								<div>
									<Field
										component={TextField}
										name="userText"
										variant="outlined"
										fullWidth
										multiline
										autoFocus
										label={this.state.reportType === 'report' ? this.context.translate('Report details') : this.context.translate('Feedback details')}
										validate={{
											presence: true
										}}
									/>
								</div>
								<div className={styles.buttonSurround}>
									<Button
										variant="contained"
										type="submit"
										className={styles.button}
									>
										{this.state.reportType === 'report' ? this.context.translate('Submit report') : this.context.translate('Submit feedback')}
									</Button>
								</div>
							</Form>
						)}
						{this.state.hasSubmitted && (
							<React.Fragment>
								<p>
									{this.state.reportType === 'report' ?
										this.context.translate('Thank you for submitting your report - it will be reviewed and actioned by a Kitfit team member as soon as possible.') :
										this.context.translate('Thank you for submitting your feedback - it will be reviewed by a Kitfit team member.')}
								</p>
								<p>
									{this.props.user.isActivated ?
										<a href={this.state.url}>{this.context.translate('Return to previous page')}</a> :
										<Link to={getStartLocationForUser(this.propsuser)}>{this.context.translate('Return to profile')}</Link>
									}
								</p>
							</React.Fragment>
						)}
					</div>
				)}
			</section>
		)
	}
}

Report.contextTypes = {
	translate: PropTypes.func
}

Report.propTypes = {
	location: PropTypes.shape({
		search: PropTypes.string
	}).isRequired,
	match: PropTypes.shape({
		path: PropTypes.string.isRequired
	}).isRequired,
	appHeading: PropTypes.func.isRequired,
	reportSave: PropTypes.func.isRequired,
	appPageLoaded: PropTypes.func.isRequired,
	pageHasLoaded: PropTypes.bool,
	user: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
}

Report.defaultProps = {
	pageHasLoaded: false
}

export const testing = {
	Report
}

export default connect(
	/* istanbul ignore next line */
	state => pick(state, ['user', 'pageHasLoaded']),
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['reportSave', 'appHeading', 'appPageLoaded'])
)(Report)



// WEBPACK FOOTER //
// ./src/Report.jsx